var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.filterComponent && _vm.usefulFilter)?_c('div',[_c('accordion',{attrs:{"title":_vm.filterLabel}},[_c(_vm.filterComponent,_vm._b({tag:"component",on:{"input":function($event){return _vm.$emit('input', $event)}}},'component',{ property: _vm.property, values: _vm.values, activeFilter: _vm.activeFilter },false))],1)],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }